<template>
  <v-dialog @keydown="esc" @click:outside="outside" :max-width="dense ? 360 : ''" hide-overlay
            :persistent="persistent"
            v-model="dialog" :fullscreen="!dense"
            :transition="dense ? 'slide-y-reverse-transition' : 'dialog-bottom-transition'">
    <template v-slot:activator="{ on }">
      <div class="activator"
           @click="open" v-on="on">
        <slot name="activator"></slot>
      </div>
    </template>
    <v-card tile>
      <div :class="['fullscreen_modal-content', desktop ? 'desktop':'']" @click="closeIfSelectable">
        <slot name="content">
        </slot>
      </div>
      <v-btn :disabled="closing_btn_disabled" tile large block color="primary" @click="close">
        <slot name="closing-btn-title">Close</slot>
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "FullscreenModalWithSlot",
    props: {
      dense: {
        type: Boolean
      },
      selectable: {
        type: Boolean
      },
      closing_btn_disabled: {
        type: Boolean,
        default: false
      },
      persistent: {
        type: Boolean,
        default: true
      }
    },

    computed: {

    },
    methods: {
      esc(pressed) {
        if (pressed.key === 'Escape') {
          this.outside()
        }
      },

      outside() {
        this.dialog = false
        this.$emit('closed', this.dialog)
      },
      open() {
        this.dialog = true
        this.$emit('opened', this.dialog)
      },
      close() {
        this.dialog = false
        this.$emit('closed', this.dialog)
        this.$emit('closed_primary', this.dialog)
      },
      closeIfSelectable() {
        if (this.selectable) {
          this.dialog = false
          this.$emit('closed', this.dialog)
        }
      }
    },
    data: () => ({
      desktop: false,
      overlay: false,
      dialog: false,
    })
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Elements/FullscreenModalWithSlot.vue